import { applyFontWeightNormal, applyScaledTypeRamp, designUnit, glyphSize, HighContrastColor, highContrastOptOutProperty, highContrastSelector, neutralForegroundHint, } from "@microsoft/fast-components-styles-msft";
import { directionSwitch, multiply, toPx } from "@microsoft/fast-jss-utilities";
const styles = {
    attribution: {
        "box-sizing": "border-box",
        display: "inline-flex",
        "align-items": "center",
        "& $attribution_image": {
            "margin-right": directionSwitch(toPx(multiply(designUnit, 2)), ""),
            "margin-left": directionSwitch("", toPx(multiply(designUnit, 2))),
        },
    },
    attribution_contentRegion: Object.assign({}, applyScaledTypeRamp("t8"), applyFontWeightNormal(), { color: neutralForegroundHint }),
    attribution_image: {
        height: glyphSize,
        [highContrastSelector]: Object.assign({}, highContrastOptOutProperty, { background: HighContrastColor.background, "border-color": HighContrastColor.text }),
    },
};
export default styles;
